import React from "react";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => ({
  timeline: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
  },
  timelineStep: {
    flex: 1,
    width: "33.33%",

    height: "4px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "2px",
    transition: "background-color 0.3s ease",
    margin: `0 ${theme.spacing(0.5)}px`, // Adjust margin between steps
  },
  activeStep: {
    backgroundColor: theme.palette.secondary.main,
  },
}));
export default function TimeLineComponent({ totalLength, activeStep }) {
  const classes = useStyles();
  return (
    <div className={classes.timeline}>
      {Array.from({ length: totalLength }).map((_, index) => (
        <div
          key={index}
          className={`${classes.timelineStep} ${
            index === activeStep ? classes.activeStep : ""
          }`}
        />
      ))}
    </div>
  );
}
